
<template>
  <div>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <div style="overflow-x: hidden">
          <v-row>
            <v-col>
              <h2>ระบบเติมเงินเครดิต</h2>
            </v-col>
          </v-row>
          <v-container>
            <v-switch v-model="statusAddcoinAfterDecrease" class="mt-0" color="green lighten-2" hide-details :label="statusAddcoinAfterDecrease === true
              ? 'เปิด' + ': แจกคะแนนหลังจากหักเครดิต'
              : 'ปิด' + ': แจกคะแนนหลังจากหักเครดิต'
              " @click="updateStatusnotifyAddcoin()"></v-switch>
            <!-- <v-checkbox
              @click="changeStatusCheckBox"
              v-model="checkbox"
              :label="`แจกคะแนนหลังจากหักเครดิต: เปิด`"
              class="mt-0"
            ></v-checkbox> -->
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="5" lg="5" class="pt-0 mt-4">
                <p style="margin-bottom: 0">
                  {{ $session.getAll().data.shopId !== shopNameData.SHOP_ID_CHUBB ? 'เบอร์โทรศัพท์':'รหัสพนักงาน' }} <span style="color: red">*</span>
                </p>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <div
                    style="
                      width: 100%;
                      display: flex;
                      flex-direction: row;
                      min-height: 25px;
                    "
                  >
                    <v-text-field
                      v-model="formAdd.tel"
                      :placeholder="$session.getAll().data.shopId !== shopNameData.SHOP_ID_CHUBB ? 'กรุณากรอกเบอร์โทรศัพท์':'กรุณากรอกรหัสพนักงาน'"
                      outlined
                      dense
                      clearable
                      required
                      hide-details
                      style="border-radius: 8px 8px"
                      @input="chkPhone"
                      @click:clear='remove()'
                    ></v-text-field>
                    <!-- <v-btn
                      color="#1b437c"
                      dark
                      style="border-radius: 0 8px 8px 0; min-height: 40px"
                      @click="validate(), addData()"
                      >ค้นหา
                    </v-btn> -->
                  </div>
                  <p style='color: #575859;font-size: 15px !important;'>แนะนำ : กรุณากรอก {{ $session.getAll().data.shopId !== shopNameData.SHOP_ID_CHUBB ? 'เบอร์โทรศัพท์ 10 หลัก':'รหัสพนักงาน 7 หลัก'}}เพื่อค้นหา</p>
                </v-form>
                <div style="padding-top: 10%">
                  <v-card style="height: 465px">

                    <v-col class="text-center">
                      <v-avatar color="primary" size="120">
                        <img
                          :src="
                            formProfile.picture !== ''
                              ? formProfile.picture
                              : 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'
                          "
                        />
                      </v-avatar>
                      <v-card-title class="text-h5">
                        <v-col class="text-center" style="padding-bottom: 0px">
                          {{
                            formProfile.name
                              ? formProfile.name
                              : "สมชาย สีสะอาด"
                          }}
                        </v-col>
                      </v-card-title>
                    </v-col>

                    <v-row>
                      <v-col>
                        <h3
                          style="
                            font-size: 16px !important;
                            padding-left: 30px;
                          "
                          class="text-left"
                        >
                          Credits คงเหลือ
                        </h3>
                      </v-col>
                      <v-col>
                        <h2
                          style="
                            font-size: 16px !important;
                            padding-left: 50px;
                          "
                          class="text-left"
                        >
                          {{
                            formProfile.point
                              ? formatNumber(formProfile.point) + " เครดิท"
                              : "-"
                          }}
                        </h2>
                      </v-col>
                    </v-row>
                    <v-divider
                      style="padding-top: 0; margin: 0px 0px"
                    ></v-divider>
                    <v-container>
                      <v-row>
                        <v-col
                          class="text-start"
                          style="color: #4a4a4a; padding-bottom: 0px"
                          >ชื่อ-สกุล</v-col
                        >
                        <v-col class="text-end" style="padding-bottom: 0px">{{
                          formProfile.nameCustomer
                            ? formProfile.nameCustomer
                            : "-"
                        }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          class="text-start"
                          style="color: #4a4a4a; padding-bottom: 0px"
                          >{{$session.getAll().data.shopId !== shopNameData.SHOP_ID_CHUBB ? 'เบอร์โทรศัพท์':'รหัสพนักงาน'}}</v-col
                        >
                        <v-col
                          class="text-end"
                          v-mask="'###-###-####'"
                          style="padding-bottom: 0px"
                          >{{ formProfile.tel ? formProfile.tel : "-" }}</v-col
                        >
                      </v-row>
                      <v-row>
                        <v-col
                          class="text-start"
                          style="color: #4a4a4a; padding-bottom: 0px"
                          >ระดับ</v-col
                        >
                        <v-col class="text-end" style="padding-bottom: 0px">{{
                          formProfile.LevelName ? formProfile.LevelName : "-"
                        }}</v-col>
                      </v-row>
                    </v-container>
                    <v-card-actions>
                      <v-row>
                        <v-col cols="6">
                          <v-btn
                            color="#25D252"
                            dark
                            :loading="loadingAdd"
                            @click="openModalInc"
                            v-if="formProfile.memberId !== ''"
                          >
                            เพิ่ม Credits
                          </v-btn>
                        </v-col>
                        <v-col cols="6" class="text-right">
                          <v-btn
                            color="#f74569"
                            :loading="loadingAdd"
                            dark
                            @click="openModalDec"
                            v-if="formProfile.memberId !== ''"
                          >
                            หัก Credits
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </div>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="7" lg="7">
                <v-card
                  style="
                    position: absolute;
                    top: 6%;
                    border-radius: 8px 8px;
                    width: 95%;
                  "
                >
                  <v-tabs
                    v-model="tab"
                    background-color="#1b437c"
                    dark
                    height="40"
                    elevation="2"
                  >
                    <v-tab v-if="formProfile.name === ''">ลูกค้าที่ยังมีเครดิตคงเหลือ</v-tab>
                    <v-tab v-if="formProfile.name !== ''"
                      >ประวัติของคุณ {{ formProfile.name }}</v-tab
                    >
                  </v-tabs>
                  <v-tabs-items v-model="tab">
                    <v-tab-item v-if="formProfile.name === ''">
                      <v-data-table
                        :headers="allCradits"
                        :items="itemAllCradits"
                        :items-per-page="10"
                        class="elevation-1"
                      >
                        <template v-slot:[`item.total_credits`]="{ item }">
                          {{ formatNumber(item.total_credits) }}
                        </template>
                        <template v-slot:[`item.current_credits`]="{ item }">
                          {{ formatNumber(item.current_credits) }}
                        </template>
                      </v-data-table>
                    </v-tab-item>
                    <v-tab-item v-if="formProfile.name !== ''">
                      <v-data-table
                      :headers="logHeaders"
                            :items="log"
                        :items-per-page="10"
                        class="elevation-1"
                      >
                        <template v-slot:[`item.total_credits`]="{ item }">
                          {{ formatNumber(item.total_credits) }}
                        </template>
                        <template v-slot:[`item.current_credits`]="{ item }">
                          {{ formatNumber(item.current_credits) }}
                        </template>
                      </v-data-table>
                    </v-tab-item>
                    <!-- <v-tab-item>
                      <v-card style="height: 200px">
                        <p>2</p>
                      </v-card>
                    </v-tab-item> -->
                  </v-tabs-items>
                </v-card>
              </v-col>
            </v-row>
            <!-- <v-form ref="form" v-model="valid" lazy-validation>
            <v-row style="max-width: 600px; padding-top: 20px" class="pb-4">
              <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <h2>กรอกเบอร์โทร และกดปุ่มตรวจสอบ</h2>
                  </v-col>
                  <v-col xs="7" sm="7" md="7" lg="7" style="padding: 0px 0px">
                    <v-text-field
                      v-model="formAdd.tel"
                      label="เบอร์โทรศัพท์"
                      placeholder='กรุณากรอกเบอร์โทรศัพท์'
                      v-mask="'###-###-####'"
                      outlined
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="4"
                    xs="4"
                    sm="4"
                    md="4"
                    lg="4"
                    class="padding-colH pb-4 mr-2"
                  >
                    <v-btn
                      block
                      large
                      color="primary"
                      @click="validate(), addData()"
                      >ตรวจสอบ
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="4" lg="4">
                    <v-card style="height: 465px">
                      <v-row>
                        <v-col class="text-center">
                          <h2>ตรวจสอบข้อมูลลูกค้า</h2>
                        </v-col>
                      </v-row>
                      <v-col class="text-center">
                        <v-avatar color="primary" size="120">
                          <img
                            :src="
                              formProfile.picture !== ''
                                ? formProfile.picture
                                : 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'
                            "
                          />
                        </v-avatar>
                        <v-card-title class="text-h5">
                          <v-col
                            class="text-center"
                            style="padding-bottom: 0px"
                          >
                            {{
                              formProfile.name
                                ? formProfile.name
                                : "สมชาย สีสะอาด"
                            }}
                          </v-col>
                        </v-card-title>
                      </v-col>

                      <v-row>
                        <v-col>
                          <h3
                            style="
                              font-size: 16px !important;
                              font-family: &quot;Kanit&quot;, sans-serif;
                              padding-left: 30px;
                            "
                            class="text-left"
                          >
                            Credits คงเหลือ
                          </h3>
                        </v-col>
                        <v-col>
                          <h2
                            style="
                              font-size: 16px !important;
                              font-family: &quot;Kanit&quot;, sans-serif;
                              padding-left: 50px;
                            "
                            class="text-left"
                          >
                            {{
                              formProfile.point
                                ? formatNumber(formProfile.point) + " คะแนน"
                                : "-"
                            }}
                          </h2>
                        </v-col>
                      </v-row>
                      <v-divider
                        style="padding-top: 0; magin: 0px 0px"
                      ></v-divider>
                      <v-container>
                        <v-row>
                          <v-col
                            class="text-start"
                            style="color: #4a4a4a; padding-bottom: 0px"
                            >ชื่อ-สกุล</v-col
                          >
                          <v-col class="text-end" style="padding-bottom: 0px">{{
                            formProfile.nameCustomer
                              ? formProfile.nameCustomer
                              : "-"
                          }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            class="text-start"
                            style="color: #4a4a4a; padding-bottom: 0px"
                            >เบอร์โทรศัพท์</v-col
                          >
                          <v-col
                            class="text-end"
                            v-mask="'###-###-####'"
                            style="padding-bottom: 0px"
                            >{{
                              formProfile.tel ? formProfile.tel : "-"
                            }}</v-col
                          >
                        </v-row>
                        <v-row>
                          <v-col
                            class="text-start"
                            style="color: #4a4a4a; padding-bottom: 0px"
                            >ระดับ</v-col
                          >
                          <v-col class="text-end" style="padding-bottom: 0px">{{
                            formProfile.LevelName ? formProfile.LevelName : "-"
                          }}</v-col>
                        </v-row>
                      </v-container>

                      <v-card-text>
                        <v-row>
                          <v-col></v-col>
                          <v-col></v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions>
                        <v-row>
                          <v-col cols="6">
                            <v-btn
                              color="#25D252"
                              dark
                              @click="openModalInc"
                              v-if="formProfile.memberId !== ''"
                            >
                              เพิ่ม Credits
                            </v-btn>
                          </v-col>
                          <v-col cols="6" class="text-right">
                            <v-btn
                              color="#f74569"
                              :loading="loadingAdd"
                              dark
                              @click="openModalDec"
                              v-if="formProfile.memberId !== ''"
                            >
                              หัก Credits
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="8" lg="8">
                    <v-tabs
                          v-model="tab"
                        >
                          <v-tabs-slider color="blue"></v-tabs-slider>

                          <v-tab v-for="item in items" :key="item.name">
                            {{ item.name }}
                          </v-tab>
                        </v-tabs>
                    <v-card style="height: 465px">
                      <v-row>

                        <v-col class="text-center">
                          <h2>ประวัติการ เพิ่ม/ลด Credits</h2>
                          <v-data-table
                            :headers="logHeaders"
                            :items="log"
                            :items-per-page="10"
                            class="elevation-1"
                          >
                            <template v-slot:item.status="{ item }">
                              <v-chip
                                :color="
                                  item.status === 'เพิ่ม'
                                    ? 'green lighten-3'
                                    : 'red lighten-3'
                                "
                              >
                                {{ item.status }}
                              </v-chip>
                            </template>
                            <template v-slot:item.credits="{ item }">
                              <div class="text-right">
                                {{ item.credits }}
                              </div>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form> -->
          </v-container>

          <v-dialog v-model="dialogInc" persistent max-width="490">
            <v-card>
              <v-container>
                <v-row>
                  <v-col cols="8">
                    <h2>เพิ่ม Credits</h2>
                  </v-col>
                  <v-col class="text-right">
                    <v-btn small color="#E0E0E0" @click="dialogInc = false">
                      <v-icon color="#173053">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-form ref="form" class="pt-8" v-model="validAdd" lazy-validation>
                  <v-row class="no-gutters">
                    <v-col cols="12">
                      <v-text-field
                        v-model="formInc.amount"
                        label="จำนวน Credits ที่ต้องการเพิ่ม"
                        dense
                        type="number"
                        :min="0"
                        outlined
                        :rules="[rules.required, rules.nonNegative]"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="formInc.customer_note"
                        label="บันทึกสำหรับ แจ้งลูกค้า"
                        outlined
                        value=""
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="formInc.admin_note"
                        label="บันทึกภายใน สำหรับร้านค้า"
                        outlined
                        value=""
                      ></v-textarea>
                    </v-col>
                    <v-col class="text-right">
                      <v-btn color="success" :loading="loadingAdd" @click="incCredits" :disabled="!validAdd">ยืนยัน</v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDec" persistent max-width="490">
            <v-card>
              <v-container>
                <v-row>
                  <v-col cols="8">
                    <h2>หัก Credits</h2>
                  </v-col>
                  <v-col class="text-right">
                    <v-btn small color="#E0E0E0" @click="dialogDec = false, clear()">
                      <v-icon color="#173053">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-form ref="form" class="pt-8" v-model="validDecress" lazy-validation>
                  <v-row class="no-gutters">
                    <v-col cols="12">
                      <v-text-field
                        v-model="formDec.amount"
                        label="จำนวน Credits ที่ต้องการหัก"
                        dense
                        type="number"
                        :min="0"
                        outlined
                        :rules="[rules.required, rules.nonNegative, rules.lessThan]"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-select
                        v-if="statusAddcoinAfterDecrease"
                        v-model="formDec.productExchangeRateId"
                        :items="ProductExchangeRate"
                        @change="updateEx(formDec.productExchangeRateId)"
                        label="กรุณาเลือก สินค้า/บริการ"
                        dense
                        outlined
                        :hide-details="multiplyPoint ? true : false"
                      ></v-select>
                      <v-chip x-small class ="mb-4 mt-2" color="rgb(78 167 78)" style="color: white" v-if="multiplyPoint">{{multiplyPoint ? `คะแนนคูณ ` + multiplyPoint : ''}}</v-chip>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="formDec.customer_note"
                        label="บันทึกสำหรับ แจ้งลูกค้า"
                        outlined
                        value=""
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="formDec.admin_note"
                        label="บันทึกภายใน สำหรับร้านค้า"
                        outlined
                        value=""
                      ></v-textarea>
                    </v-col>
                    <v-col class="text-right" v-if="statusAddcoinAfterDecrease === false">
                      <v-btn color="success" :loading="loadingAdd" :disabled="!validDecress" @click="decCredits">ยืนยัน</v-btn>
                    </v-col>
                    <v-col class="text-right" v-else>
                      <v-btn color="success" :loading="loadingAdd" :disabled="!validDecress || !formDec.productExchangeRateId" @click="decCredits">ยืนยัน</v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import moment from 'moment'
// import constants from '@/constants.js'

export default {
  components: {
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
    }
  },
  data () {
    return {
      checkbox: true,
      exchangeRate: null,
      aa: '',
      dataNew: null,
      multiplyPoint: null,
      session: this.$session.getAll(),
      path: '/AddCoin/', // Path Model
      returnLink: '/Master/AddCoin',
      valid: true,
      dialogInc: false,
      dialogDec: false,
      profile: false,
      statusAddcoinAfterDecrease: null,
      formAdd: {
        tel: ''
      },
      formInc: {
        amount: '',
        admin_note: '',
        customer_note: ''
      },
      formDec: {
        amount: '',
        admin_note: '',
        customer_note: ''
      },
      formProfile: {
        picture: '',
        name: '',
        tel: '',
        point: '',
        totalpoint: '',
        LevelName: '',
        nameCustomer: '',
        memberId: '',
        points: ''
      },
      rules: {
        required: (value) => !!value || 'กรุณากรอก.',
        nonNegative: (value) => parseInt(value) > 0 || 'ห้ามน้อยกว่าหรือเท่ากับ 0',
        lessThan: (value) => parseInt(value) <= this.formProfile.point || 'ห้ามมากกว่าเครดิทปัจจุบัน'
      },
      ProductExchangeRate: [],
      dataBranch: [],
      confirmBtn: true,
      cancelBtn: false,
      validAdd: true,
      validDecress: true,
      them: '',
      loadingAdd: false,
      loading: false,
      dataItemImport: [],
      dataIm: [],
      importPoint: {
        productExchangeRateId: '',
        amount: '',
        masBranchID: ''
      },
      dataMember: null,
      file: null,
      data: {},
      log: [],
      logHeaders: [
        {
          text: 'วันที่',
          align: 'start',
          sortable: true,
          value: 'CREATE_DATE'
        },
        { text: 'สถานะ', value: 'status' },
        { text: 'Credits', value: 'credits' },
        { text: 'บันทีกแจ้งลูกค้า', value: 'customer_note' },
        { text: 'บันทึกภายใน', value: 'admin_note' }
      ],
      itemAllCradits: [],
      allCradits: [
        { text: 'ชื่อไลน์', value: 'name' },
        { text: 'ชื่อ-สกุล', value: 'nameCustomer' },
        {
          text: 'เครดิตที่รับทั้งหมด',
          value: 'total_credits',
          align: 'center'
        },
        { text: 'เครดิตคงเหลือ', value: 'current_credits', align: 'center' }
      ],
      formatter: new Intl.NumberFormat('th-TH', {
        currency: 'THB'
      }),
      tab: null,
      AllCrefits: []
    }
  },

  async mounted () {
    moment.locale('th')
    this.getDataMember()
    this.sessionCheck()
    this.getDataAll()
    this.getProductExchangeRate()
    this.checkStatusAddcoinDecrease()
    // this.statusAddcoinAfterDecrease = this.$session.getAll().data.add_point_after_decrease
  },
  methods: {
    openModalInc () {
      this.dialogInc = true
    },
    openModalDec () {
      this.dialogDec = true
    },
    sessionCheck () {
    },
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    addData () {
      if (this.$refs.form.validate() === true) {
        this.getDataProfile()
      }
    },
    async getDataProfile (item) {
      axios
        .get(
          this.DNS_IP +
            '/getCredits?shopId=' +
            this.session.data.shopId +
            '&tel=' +
            item
        )
        .then((result) => {
          if (result.data.status === false) {
            this.$swal(
              'ไม่พบบัญชีผู้ใช้',
              'กรุณาตรวจสอบหมายเลขโทรศัพท์',
              'error'
            )
            this.confirmBtn = true
            this.clearProfile()
          } else {
            this.profile = true
            if (result.data[0].pictures !== '') {
              this.formProfile.picture = result.data[0].picture
            } else {
              this.formProfile.picture =
                'https://cdn.vuetifyjs.com/images/cards/cooking.png'
            }
            this.formProfile.picture = result.data[0].picture
            this.formProfile.name = result.data[0].name
            this.formProfile.tel = result.data[0].tel
            this.formProfile.point = result.data[0].current_credits
            this.formProfile.totalPoint = result.data[0].total_credits
            this.formProfile.LevelName = result.data[0].LevelName
            this.formProfile.nameCustomer = result.data[0].nameCustomer
            this.formProfile.memberId = result.data[0].memberId
            this.getDataLog()
          }
        })
    },
    async getDataLog () {
      this.log = []
      axios
        .get(
          this.DNS_IP +
            '/getCredits_Log?shopId=' +
            this.session.data.shopId +
            '&memberId=' +
            this.formProfile.memberId
        )
        .then((result) => {
          if (result.data.status !== false) {
            this.log = result.data.map((row) => {
              let d = new Date(row.CREATE_DATE)
              row.CREATE_DATE =
              [d.getDate(), d.getMonth() + 1, d.getFullYear()].join('/') +
              ' ' +
              [d.getHours() - 7, d.getMinutes(), d.getSeconds()].join(':')

              row.status = row.status === 'increase' ? 'เพิ่ม' : 'หัก'
              row.credits = this.formatter.format(row.credits)
              return row
            })
          } else {
            return null
          }
        })
    },
    async incCredits () {
      this.loadingAdd = true
      var data = {
        memberId: this.formProfile.memberId,
        Amount_credited: this.formInc.amount,
        admin_note: this.formInc.admin_note,
        customer_note: this.formInc.customer_note,
        time: moment().format('LT'),
        date: moment().format('Do MMM YYYY')
      }
      // alert('fff')
      axios.post(this.DNS_IP + '/increase', data).then((response) => {
        this.$swal('เรียบร้อย', 'เพิ่ม Credits เรียบร้อย', 'success')
        this.clear()
        this.reset()
        this.clearProfile()
        this.dialogInc = false
        this.loadingAdd = false
        this.getDataAll()
      })
    },
    async decCredits () {
      this.loadingAdd = true
      // const currentDate = moment()
      // const formattedDate = currentDate.format('DD/MM/YYYY')
      var data = {
        memberId: this.formProfile.memberId,
        Amount_credited: this.formDec.amount,
        admin_note: this.formDec.admin_note,
        customer_note: this.formDec.customer_note,
        time: moment().format('LT'),
        date: moment().format('Do MMM YYYY')
      }
      if (this.formDec.productExchangeRateId !== '' && this.formDec.productExchangeRateId) {
        if (this.multiplyPoint) {
          let point = parseInt(this.formDec.amount) / parseInt(this.exchangeRate) * this.multiplyPoint
          data.pointAfterDecrease = point
        } else {
          let point = parseInt(this.formDec.amount) / parseInt(this.exchangeRate)
          data.pointAfterDecrease = point
        }
      }
      // console.log('ยิงคะแนน', data)
      await axios.post(this.DNS_IP + '/decrease', data).then((response) => {})
      if (this.statusAddcoinAfterDecrease === true) {
        var dataPos = {
          shopId: this.$session.getAll().data.shopId,
          tel: this.formProfile.tel,
          Amount: this.formDec.amount,
          exchangRateId: this.formDec.productExchangeRateId,
          masBranchID: this.session.data.masBranchID,
          source: false,
          employee: this.session.data.displayName,
          branchName: this.session.data.masBranchName,
          decrease: 'decrease'
        }
        await axios.post(this.DNS_IP + '/POSapi', dataPos).then((response) => {})
      }
      this.clearProfile()
      this.reset()
      this.clear()
      this.$swal('เรียบร้อย', 'หัก Credits เรียบร้อย', 'success')
      // this.getDataProfile()
      this.dialogDec = false
      this.loadingAdd = false
      this.getDataAll()
    },
    clear () {
      this.formInc.amount = ''
      this.formInc.admin_note = ''
      this.formInc.customer_note = ''
      this.formDec.amount = ''
      this.formDec.admin_note = ''
      this.formDec.customer_note = ''
      this.formDec.customer_note = ''
      this.formDec.productExchangeRateId = null
      this.multiplyPoint = null
      this.exchangeRate = null
      this.confirmBtn = true
    },
    clearProfile () {
      this.log = []
      this.formProfile.picture = ''
      this.formProfile.name = ''
      this.formProfile.tel = ''
      this.formProfile.point = ''
      this.formProfile.totalPoint = ''
      this.formProfile.LevelName = ''
      this.formProfile.nameCustomer = ''
      this.formProfile.memberId = ''
      this.formAdd.tel = null
    },
    getDataMember () {
      //   this.dataMember = []
      axios
        .get(this.DNS_IP + '/member/get?shopId=' + this.session.data.shopId)
        .then((res) => {
          //   this.dataMember = res.data
          this.dataMember = res.data.map((el) => el.tel)
          //   console.log('mem', this.dataMember)
        })
    },
    clearDataImp () {
      this.importPoint.productExchangeRateId = ''
      this.importPoint.amount = ''
      this.importPoint.masBranchID = ''
      this.dialogImport = false
      this.dataItemImport = []
    },
    getDataAll () {
      axios
        .get(
          this.DNS_IP +
            '/getCredits?shopId=' +
            this.session.data.shopId +
            '&current_credits=0'
        )
        .then((res) => {
          this.itemAllCradits = []
          if (res.data.status !== false) {
            this.itemAllCradits = res.data
          } else {
            this.itemAllCradits = []
          }
        })
    },
    async chkPhone () {
      if (this.$session.getAll().data.shopId !== this.shopNameData.SHOP_ID_CHUBB) {
        if (this.formAdd.tel.split('-').join('').trim().length > 9) {
          var newTel = this.formAdd.tel.split('-').join('').trim()
          await this.getDataProfile(newTel)
        }
      } else {
        if (this.formAdd.tel.length > 6) {
          await this.getDataProfile(this.formAdd.tel)
        }
      }
    },
    remove () {
      this.clearProfile()
    },
    async getProductExchangeRate () {
      this.ProductExchangeRate = []
      await axios
        .get(
          this.DNS_IP +
          '/productExchangeRate/' +
          'get?shopId=' +
          this.$session.getAll().data.shopId
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.productExchangeRateId
            s.text = d.name
            s.exchangeRate = d.exchangeRate
            s.userId = d.userId
            s.allData = d
            this.ProductExchangeRate.push(s)
          }
          if (this.ProductExchangeRate.length === 1) {
            this.formDec.productExchangeRateId = this.ProductExchangeRate[0].value
            this.formDec.name = this.ProductExchangeRate[0].text
            this.exchangeRate = this.ProductExchangeRate[0].exchangeRate
          } else {
            var a = this.ProductExchangeRate.filter((el) => {
              if (
                el.value === this.$session.getAll().data.productExchangeRateId
              ) {
                return el
              }
            })
            if (a.length > 0) {
              this.formAdd.productExchangeRateId = a[0].value
              this.formAdd.name = a[0].text
            }
            // console.log('f')
          }
          // console.log('this.ProductExchangeRate : ', this.ProductExchangeRate)
        })
        .catch((error) => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    async updateStatusnotifyAddcoin () {
      try {
        if (this.statusAddcoinAfterDecrease === true) {
          this.dataNew = this.$session.getAll().data
          this.dataNew.add_point_after_decrease = 'True'
        } else {
          this.dataNew = this.$session.getAll().data
          this.dataNew.add_point_after_decrease = 'False'
        }
        localStorage.setItem('data', JSON.stringify(this.dataNew))
        this.$session.set('data', this.dataNew)
        this.checkStatusAddcoinDecrease()
        const DT = {
          add_point_after_decrease: this.statusAddcoinAfterDecrease
        }
        await axios
          .post(this.DNS_IP + '/system_shop/edit/' + this.$session.getAll().data.shopId, DT)
          .then((res) => {
          })
        // console.log('aaa', DT)
      } catch (error) {
        console.log('error', error)
      }
    },
    checkStatusAddcoinDecrease () {
      try {
        if (
          this.$session.getAll().data.add_point_after_decrease.toLowerCase() ===
          'true'
        ) {
          this.statusAddcoinAfterDecrease = true
        } else {
          this.statusAddcoinAfterDecrease = false
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    updateEx (item) {
      try {
        this.multiplyPoint = null
        let ok = this.ProductExchangeRate.filter(items => items.value === item)
        this.exchangeRate = ok[0].allData.exchangeRate
        if (ok.length > 0) {
          if (ok[0].allData.multiplyPoint) {
            let startDate = new Date(ok[0].allData.startMultiplyPoint).setHours(0, 0, 0, 0)
            let endDate = new Date(ok[0].allData.endMultiplyPoint).setHours(0, 0, 0, 0)
            let todaysDate = new Date().setHours(0, 0, 0, 0)
            if (startDate <= todaysDate && endDate >= todaysDate) {
              this.multiplyPoint = ok[0].allData.multiplyPoint
            }
          }
        }
      } catch (error) {
        console.log('error', error)
      }
    }
  }
}
</script>
<style scoped>
.padding-colH {
  padding: 5px 15px 0px;
}

.red {
  color: red;
}
div.container4 {
  height: 14em;
  display: flex;
  align-items: center;
  justify-content: center;
}
div.container4 p {
  margin: 0;
}
/* style */
.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #f2f4f7;
}
@media screen and (min-width: 320px) {
  /* smartphones, iPhone, portrait 480x320 phones */
  div .div1 {
    width: 100%;
    height: 180px;
    /* display: flex;
    align-items: center;
    justify-content: center; */
  }
  div h3 {
    font-size: 16px !important;
  }
  h2.text-h {
    /* font-family: 'Poppins'; */
    font-style: normal;
    font-weight: 600;
    font-size: 24px !important;
    line-height: 160%;
    color: #667085;
  }
}

@media screen and (min-width: 481px) {
  /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */
  div h3 {
    font-size: 14px !important;
  }
}
@media screen and (min-width: 641px) {
  /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */
}
@media screen and (min-width: 961px) {
  /* tablet, landscape iPad, lo-res laptops ands desktops */
}
@media screen and (min-width: 1025px) {
  /* big landscape tablets, laptops, and desktops */
}
@media screen and (min-width: 1281px) {
  /* hi-res laptops and desktops */
}
</style>



// WEBPACK FOOTER //
// src/components/Credits/Manage.vue